"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapLinkData = void 0;
var _BurgerMenuIcon = require("./BurgerMenuIcon");
var _jsxRuntime = require("react/jsx-runtime");
const mapLinkData = data => (data ?? []).filter(item => !!item.title).map((item, index) => ({
  id: item.id ?? item.title,
  relativeUrl: item.url ?? '',
  title: item.title,
  icon: !!item.url || index > 0 ? undefined : /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuIcon.BurgerMenuIcon, {}),
  iconPosition: 'start'
}));
exports.mapLinkData = mapLinkData;